export function exec(code, data) {
  throw new Error("wasm is not supported by browser");
}
